import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AccountPaymentReviewTable, AccountAuthorisationPanel } from 'web-ui-components/lib/finance/accounts';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import iftReviewContent, { contentPropTypes } from './iftReview.content';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import Notifications from '../../../sharedComponents/Notifications';
import {
	getIFTPaymentsForReview,
	getIFTPaymentsRequireAuthorisers,
	getIFTPaymentsRequireAuthorisersGroup,
	getSomePaymentRatesAreIndicative,
} from '../../../states/ift/selectors';
import { parseString } from '../../../helpers/contentParser';
import { goToPage, pages } from '../../../states/page/actions';
import IFTAuthoriserViewer from '../IFTAuthoriserViewer/IFTAuthoriserViewer';
import IFTAuthoriserSelector from '../IFTAuthoriserSelector/IFTAuthoriserSelector';
import { isPaymentInEditMode } from '../../../states/modes/selectors';
import { getAuthorisationMessage } from '../../../helpers/fieldHelpers';
import { getUserId } from '../../../states/user/selectors';

import { paymentReviewContent } from '../../../sharedComponents/PaymentReview/PaymentReview.content';

const mapState = (state) => ({
	hasApiCallInProgress: hasApiCallInProgress(state),
	paymentsRequireAuthorisers: getIFTPaymentsRequireAuthorisers(state),
	paymentsRequireAuthorisersGroup: getIFTPaymentsRequireAuthorisersGroup(state),
	paymentsToReview: getIFTPaymentsForReview(state),
	showIndicative: getSomePaymentRatesAreIndicative(state),
	isPaymentInEditMode: isPaymentInEditMode(state),
	userId: getUserId(state),
});

const mapDispatch = (dispatch) => ({
	handleBack: (navigationPage) => dispatch(goToPage(navigationPage)),
});

class IFTReviewPage extends Component {
	constructor(props) {
		super(props);

		this.handleBack = this.handleBack.bind(this);

		this.state = { showAuthModal: false, paymentSelectedId: undefined };
	}
	componentDidMount() {
		this.props.handlePaymentInReview(true);
	}

	componentWillUnmount() {
		this.props.handlePaymentInReview(false);
	}

	handleBack() {
		const { isPaymentInEditMode, handleBack } = this.props;
		if (isPaymentInEditMode) return handleBack(pages.IFTPaymentDetails);
		return handleBack(pages.IFTPayments);
	}

	render() {
		const {
			handleContinue,
			content,
			hasApiCallInProgress,
			paymentsRequireAuthorisers,
			paymentsRequireAuthorisersGroup,
			paymentsToReview,
			showIndicative,
			userId,
			hasGroupApprovalsEnabled,
		} = this.props;

		const isPaymentsAuthorisersRequired = hasGroupApprovalsEnabled
			? paymentsRequireAuthorisersGroup
			: paymentsRequireAuthorisers;

		const { noAvailableAuthorisersErrorMessage } = paymentReviewContent;

		console.log();

		return (
			<div>
				<PageHeading isFlush data-test-id="ift-review-page">
					{content.PageHeader}
				</PageHeading>
				<p className="u-margin-top-1">{content.PageSubHeader}</p>
				<div className="u-margin-bottom-2">
					<Notifications />
				</div>
				{paymentsToReview.length && (
					<AccountAuthorisationPanel>
						<p>{content.AuthorisationBodyMsg}</p>
					</AccountAuthorisationPanel>
				)}
				{paymentsToReview.map((payment) => {
					const authorisersGroup = payment.authorisersGroup;
					const hasNoAvailableAuthorisers = isPaymentsAuthorisersRequired && authorisersGroup.length === 0;
					const getStatusError = hasNoAvailableAuthorisers && noAvailableAuthorisersErrorMessage;

					if (payment.isDefaultAuthorisers) {
						return (
							<AccountPaymentReviewTable.Authorisation
								authorisers={payment.authorisers}
								statusContent={getAuthorisationMessage(payment.authorisers, userId)}
								statusTitle={payment.statusTitle}
								tableData={payment.tableData}
								key={payment.id}
								statusErrorContent={getStatusError}
							/>
						);
					}
					return hasGroupApprovalsEnabled ? (
						<div>
							<AccountPaymentReviewTable.Authorisation
								authorisers={payment.authorisers}
								viewAuthorisersOnClick={() => this.setState({ showAuthModal: true, paymentSelectedId: payment.id })}
								statusContent={getAuthorisationMessage(payment.authorisers, userId)}
								statusTitle={payment.statusTitle}
								tableData={payment.tableData}
								key={payment.id}
								statusErrorContent={getStatusError}
							/>
						</div>
					) : (
						<div>
							<AccountPaymentReviewTable.Authorisation
								authorisers={payment.authorisers}
								selectAuthorisersOnClick={() => this.setState({ showAuthModal: true, paymentSelectedId: payment.id })}
								changeAuthorisersOnClick={() => this.setState({ showAuthModal: true, paymentSelectedId: payment.id })}
								statusContent={getAuthorisationMessage(payment.authorisers, userId)}
								statusTitle={payment.statusTitle}
								tableData={payment.tableData}
								key={payment.id}
								statusErrorContent={getStatusError}
							/>
						</div>
					);
				})}

				{hasGroupApprovalsEnabled ? (
					<IFTAuthoriserViewer
						isOpen={this.state.showAuthModal}
						paymentId={this.state.paymentSelectedId}
						onClose={() => this.setState({ showAuthModal: false })}
					/>
				) : (
					<IFTAuthoriserSelector
						isOpen={this.state.showAuthModal}
						paymentId={this.state.paymentSelectedId}
						onClose={() => this.setState({ showAuthModal: false })}
					/>
				)}

				{showIndicative && (
					<div>
						<p>{parseString(content.importantInfoHeader)}</p>
						<p>{parseString(content.importantInfoText)}</p>
					</div>
				)}
				<PageNavigation
					handleContinue={handleContinue}
					showContinue
					enableContinue={!hasApiCallInProgress && !isPaymentsAuthorisersRequired}
					showBack
					handleBack={this.handleBack}
					enableBack={!hasApiCallInProgress}
					continueButtonText={content.continueButtonText}
					showLoading={hasApiCallInProgress}
				/>
			</div>
		);
	}
}

IFTReviewPage.propTypes = {
	handleContinue: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	hasApiCallInProgress: PropTypes.bool.isRequired,
	paymentsRequireAuthorisers: PropTypes.bool,
	paymentsToReview: PropTypes.arrayOf(PropTypes.shape({})),
	handlePaymentInReview: PropTypes.func.isRequired,
	showIndicative: PropTypes.bool.isRequired,
	isPaymentInEditMode: PropTypes.bool.isRequired,
};

const contentWrapper = withContent({ content: iftReviewContent });
export default connect(mapState, mapDispatch)(withScrollTop(contentWrapper(IFTReviewPage)));
export const ConnectWrapper = connect(mapState, mapDispatch)(IFTReviewPage);
